/**
 * Import the external scripts from our node_modules packages
 */
import MutationObserver from "mutationobserver-shim";
import Modernizr from "modernizr";
import * as $ from "jquery";
import conditionizr from "conditionizr/dist/conditionizr.min.js";
import { WOW } from "wowjs/dist/wow";
// import matchHeight from 'jquery-match-height/dist/jquery.matchHeight-min.js';
import "slick-carousel/slick/slick.min.js";
const Isotope = require("isotope-layout");
// import {zoom} from 'jquery-zoom';
// import mediumZoom from 'medium-zoom'
// import zoom from 'jquery-zoom/jquery.zoom.min.js';

/**
 * Import the internal scripts from our js folder
 */
// import { responsiveMenu } from './responsiveMenu';

/**
 * Import the WooCoomerce Scripts
 */
import { woo } from "../../woocommerce/assets/js/main.js";

/**
 * Is the element completely in the viewport vertically?
 */

$.fn.isInViewport = function() {
  var elementTop = $(this).offset().top;
  var elementBottom = elementTop + $(this).outerHeight();
  var viewportTop = $(window).scrollTop();
  var viewportBottom = viewportTop + $(window).height();
  return elementBottom > viewportTop && elementTop < viewportBottom;
};

/**
 * Is the element completely in the viewport horizontally?
 */
$.fn.isInViewportHoz = function() {
  let elementLeft = $(this).offset().left;
  let elementWidth = $(this).width();
  let viewportWidth = $(window).width();
  if (elementLeft < 0) {
    return false;
  }
  if (elementLeft + elementWidth < viewportWidth + 100) {
    return true;
  }
};

/**
 * Random Int From Range
 */
function randomIntFromInterval(min, max) {
  return Math.floor(Math.random() * (max - min + 1) + min);
}

/**
 * Call the functions when the document is ready
 */
$(document).ready(function() {
  init();
});

/**
 * Call the functions when the window is resized
 */
$(window).on("resize", () => {
  spacer();
  snapHeightToVh();
  productFeaturesGrid();
  imgLightBoxes();
});

/**
 * Setup the functions we want to call when the page loads.
 */
function init() {
  runConditionizer();
  wowSetup();
  headerScroll();
  hashScroll();
  spacer();
  latestProductsSlider();
  latestTestimonialsSlider();
  misc();
  shopStrapSlider();
  productCardImageSlider();
  videoLightbox();
  productDetailsGallery();
  productFeaturesGrid();
  archiveProductFilters();
  // partnershipLogos();
  snapHeightToVh();
  videosSlider();
  filterTaxTypes();
  filterTags();
  siteSearch();
  splashAnimation();
  customCurrencySwitcher();
  postsFiltersMobile();
  compatibleImage();
  loadMoreProducts();
  imgLightBoxes();
  responsiveMenu();
  partnerLogoSlick();
}

function responsiveMenu() {
  const menuNavWrap = $(".menu-responsive__nav--main");
  $("body").on("click", ".mobile-toggle", function() {
    mobileToggle($(this), menuNavWrap);
  });

  const menuAccountWrap = $(".menu-responsive__nav--account");
  $("body").on("click", ".mobile-controls__item--account", function() {
    mobileToggle($(this), menuAccountWrap);
  });

  const menuBasketWrap = $(".menu-responsive__nav--basket");
  $("body").on("click", ".mobile-controls__item--basket", function() {
    mobileToggle($(this), menuBasketWrap);
  });

  childItemsHandler();
}

function mobileToggle(trigger, menu) {
  if ($(trigger).hasClass("is-active")) {
    $(".menu-responsive").removeClass("is-active");
    $(trigger).removeClass("is-active");
    $(menu).removeClass("is-active");
    $("body").removeClass("is-overflow-h");
  } else {
    $(".menu-responsive").addClass("is-active");
    $(trigger).addClass("is-active");
    $(menu).addClass("is-active");
    $("body").addClass("is-overflow-h");
  }

  if ($(menu).find(".sub-menu").length) {
    if (
      $(menu)
        .find(".sub-menu")
        .hasClass("is-active")
    ) {
      $(menu)
        .find(".sub-menu")
        .removeClass("is-active");
      return;
    }
  }

  $(".sub-menu").removeClass("is-active");
  $(".mobile-trigger-item")
    .not($(trigger))
    .removeClass("is-active");
  $(".menu-responsive__nav")
    .not($(menu))
    .removeClass("is-active");
  // $('body').toggleClass('is-overflow-h');
}

function childItemsHandler() {
  if ($(window).width() <= 1024) {
    $(".menu-item-has-children > a").on("click", function(e) {
      e.preventDefault();
      $(this).addClass("is-active");
      $(this)
        .parent()
        .find(".sub-menu")
        .addClass("is-active");
    });
  }
}

function imgLightBoxes() {
  if ($(window).width() > 1025) {
    var elm = $(".woocommerce-product-gallery__featured");
  } else {
    var elm = $(".woocommerce-product-gallery__thumb");
  }
  elm.on("click", function() {
    $(".lightbox img").remove();
    var src = $(this)
      .find("img")
      .attr("src");
    $("main").addClass("off-canvas");
    $(".lightbox").append('<img src="' + src + '" />');
    $(".lightbox").addClass("is-visible");
  });

  var imgElm = $(".blog-post-content__content-wrap .wp-block-image a");
  imgElm.on("click", function(e) {
    e.preventDefault();
    $(".lightbox img").remove();
    var src = $(this)
      .find("img")
      .attr("src");
    $("main").addClass("off-canvas");
    $(".lightbox").append('<img src="' + src + '" />');
    $(".lightbox").addClass("is-visible");
  });
}

function loadMoreProducts() {
  var scrollTimeout;
  var throttle = 50;
  var trigger = $("#js-load-more-products");
  var running = false;

  $(window).on("scroll", function() {
    if (!scrollTimeout) {
      scrollTimeout = setTimeout(function() {
        if ($(trigger).length) {
          if ($(trigger).isInViewport()) {
            if (running == false) {
              running = true;
              loadMoreProductsAjax();
            }
          }
        }

        scrollTimeout = null;
      }, throttle);
    }
  });

  function loadMoreProductsAjax() {
    var offset = $("#products-container .product-card").length;
    var archive_id;
    var args_orderby;
    var args_order;
    var args_m_key;
    $("#spinner").show();

    if ($("#archive_id").length) {
      archive_id = $("#archive_id").val();
    } else {
      archive_id = false;
    }

    if ($("#args_orderby").length) {
      args_orderby = $("#args_orderby").val();
      args_order = $("#args_order").val();
    } else {
      args_orderby = false;
      args_order = false;
    }

    if ($("#args_m_key").length && $("#args_m_key").val() == "_price") {
      args_m_key = "_price";
    } else {
      args_m_key = false;
    }

    $.ajax({
      url: urls.ajaxUrl,
      type: "post",
      dataType: "json",
      data: {
        action: "getNextProducts",
        offset: offset,
        archive_id: archive_id,
        args_orderby: args_orderby,
        args_order: args_order,
        args_m_key: args_m_key,
      },
      success: function(data) {
        if (data.count > 0) {
          $("#products-container").append(data.result);
          $("#spinner").hide();
          running = false;

          // Re-initialize slick sliders
          $(".js-product-card-slider").each(function() {
            if (!$(this).hasClass("slick-initialized")) {
              $(this).slick({
                dots: false,
                infinite: true,
                arrows: true,
                prevArrow:
                  '<button type="button" class="product-card-slick-arrow slick-prev"><i class="uil uil-angle-left"></i></button>',
                nextArrow:
                  '<button type="button" class="product-card-slick-arrow slick-next"><i class="uil uil-angle-right"></i></button>',
                speed: 200,
                slidesToShow: 1,
                fade: false,
                rows: 0,
                autoplay: false,
                mobileFirst: true,
              });
            }
          });
          document.dispatchEvent(new Event("DOMContentLoaded"));
        } else {
          $(trigger).remove();
        }
      },
      error: function(e) {
        console.log(e);
      },
    });
  }
}

/**
 * Home page splash animation
 */
function splashAnimation() {
  if ($(".page-loader").length) {
    setTimeout(function() {
      $(".page-loader").addClass("is-animating");
    }, 150);
    setTimeout(function() {
      $(".page-loader").removeClass("is-visible");
    }, 6500);
  }
}

/**
 * Object fit polyfill
 */
function compatibleImage() {
  if (!Modernizr.objectfit) {
    $(".compatible-image").each(function() {
      const this_image = $(this);
      const this_src = this_image.find("img").prop("src");
      if (this_src) {
        this_image
          .css("backgroundImage", "url(" + this_src + ")")
          .addClass("background-image");
      }
    });
  }
}

/**
 * Setup Conditionizer
 */
function runConditionizer() {
  conditionizr.config({
    assets: "<?php echo get_template_directory_uri(); ?>",
    tests: {},
  });
}

function wowSetup() {
  var wow = new WOW({
    boxClass: "js-animate",
    animateClass: "is-animated",
    offset: 100,
    mobile: true,
    live: !Modernizr.mutationobserver,
  });
  wow.init();

  var $heroSection = $(".fp-hero-section");
  var shouldZoom = $heroSection.data("zoom");

  if (shouldZoom === true || shouldZoom === "true") {
    setTimeout(function() {
      $heroSection.addClass("is-animated");
    }, 750);
  }
}

/**
 * When you click a '#' animate the scroll the page to that point
 */
function hashScroll() {
  //Smooth scrolling with links
  $("a[href*=\\#]").on("click", function(event) {
    event.preventDefault();
    $("html,body").animate({ scrollTop: $(this.hash).offset().top - 130 }, 500);
  });

  // Smooth scrolling when the document is loaded and ready
  $(window).on("load", function() {
    if ($(location.hash).length) {
      $("html,body").animate(
        { scrollTop: $(location.hash).offset().top - 130 },
        500
      );
    }
  });
}

/**
 * When you scroll down, add a class to header to make it smaller
 */
function headerScroll() {
  var lastScrollTop = 0;

  $(window).scroll(function(event) {
    var st = $(this).scrollTop();

    if (st > lastScrollTop && lastScrollTop >= 75) {
      $(".header").addClass("is-scrolled");
    } else {
      $(".header").removeClass("is-scrolled");
    }

    lastScrollTop = st;
  });
}

/**
 * Make the spacer div the same height as the header
 */
function spacer() {
  var headerHeight = $(".header").outerHeight();
  $(".spacer").css("padding-bottom", headerHeight);
}

function latestProductsSlider() {
  $(".js-latest-products-slider").slick({
    dots: false,
    infinite: false,
    arrows: true,
    speed: 500,
    slidesToShow: 3,
    rows: 0,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 2,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
        },
      },
    ],
  });

  $(".js-latest-products-slider").on("afterChange", function(
    event,
    slick,
    currentSlide
  ) {
    if (
      $(".js-latest-products-slider .slick-slide")
        .last()
        .hasClass("slick-active")
    ) {
      $(".js-latest-products-slider .slick-next").addClass(
        "will-reset-first-next"
      );
    } else {
      $(".js-latest-products-slider .slick-next").removeClass(
        "will-reset-first-next"
      );
    }
    if (
      $(".js-latest-products-slider .slick-slide")
        .first()
        .hasClass("slick-active")
    ) {
      $(".js-latest-products-slider .slick-prev").addClass(
        "will-reset-last-next"
      );
    } else {
      $(".js-latest-products-slider .slick-prev").removeClass(
        "will-reset-last-next"
      );
    }
  });

  $(document).on("click", ".will-reset-first-next", function() {
    $(".js-latest-products-slider").slick("slickGoTo", 0);
    $(this).removeClass("will-reset-first-next");
  });

  $(document).on("click", ".will-reset-last-next", function() {
    var slidesToShow = $(".js-latest-products-slider").get(0).slick.options
      .slidesToShow;
    var lastIndex =
      $(".js-latest-products-slider .slick-slide").length - slidesToShow;
    $(this).removeClass("will-reset-last-next");
    $(".js-latest-products-slider").slick("slickGoTo", lastIndex);
    console.log(lastIndex);
  });

  $(".js-latest-products-slider .slick-prev").addClass("will-reset-last-next");
}

function latestTestimonialsSlider() {
  $(".js-testimonials-slider").slick({
    dots: true,
    infinite: true,
    arrows: false,
    speed: 200,
    slidesToShow: 1,
    fade: true,
    rows: 0,
    autoplay: true,
    autoplaySpeed: 5000,
    adaptiveHeight: true,
  });
}

function shopStrapSlider() {
  $(".js-shop-strap-slider").slick({
    dots: false,
    infinite: true,
    arrows: false,
    speed: 200,
    slidesToShow: 1,
    fade: false,
    rows: 0,
    autoplay: true,
    autoplaySpeed: 5000,
    mobileFirst: true,
    responsive: [
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 2,
        },
      },
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
        },
      },
    ],
  });

  $(".js-shop-strap-slider")
    .find(".slick-active")
    .last()
    .addClass("has-no-border");

  // On before slide change
  $(".js-shop-strap-slider").on("afterChange", function(
    event,
    slick,
    currentSlide,
    nextSlide
  ) {
    $(this)
      .find(".slick-active")
      .removeClass("has-no-border");
    $(".js-shop-strap-slider")
      .find(".slick-active")
      .last()
      .addClass("has-no-border");
  });
}

function productCardImageSlider() {
  $(".js-product-card-slider").slick({
    dots: false,
    infinite: true,
    arrows: true,
    prevArrow:
      '<button type="button" class="product-card-slick-arrow slick-prev"><i class="uil uil-angle-left"></i></button>',
    nextArrow:
      '<button type="button" class="product-card-slick-arrow slick-next"><i class="uil uil-angle-right"></i></button>',
    speed: 200,
    slidesToShow: 1,
    fade: false,
    rows: 0,
    autoplay: false,
    mobileFirst: true,
  });
}

function partnerLogoSlick() {
  $(".js-partner-logos-slick").slick({
    dots: false,
    infinite: true,
    arrows: false,
    speed: 200,
    slidesToShow: 2,
    fade: false,
    rows: 0,
    autoplay: true,
    autoplaySpeed: 5000,
    mobileFirst: true,
    responsive: [
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 4,
        },
      },
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 6,
        },
      },
    ],
  });
}

function productDetailsGallery() {
  $(".js-product-detailing-slider").slick({
    dots: false,
    infinite: true,
    arrows: true,
    speed: 900,
    slidesToShow: 1,
    centerMode: true,
    variableWidth: false,
    fade: false,
    rows: 0,
    draggable: true,
    mobileFirst: true,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          variableWidth: true,
        },
      },
    ],
  });
}

function misc() {
  $(".footer-input-wrap")
    .parent()
    .addClass("footer-input-row");
  $(".forminator-select-list")
    .closest(".forminator-col")
    .addClass("has-highest-z-index");
}

function videoLightbox() {
  var embedContainer = $(".embed-container");
  var playButton = $(".js-video-lightbox");

  // On Close
  $(".lightbox i").on("click", function() {
    var video = embedContainer.find("iframe");

    embedContainer.removeClass("is-visible");

    setTimeout(function() {
      $("main").removeClass("off-canvas");
      $(".lightbox").removeClass("is-visible");

      // Hide all iframes in lightbox
      video.hide();

      // Reset iframes
      video.each(function() {
        $(this).attr("src", $(this).attr("src"));
      });
    }, 250);
  });

  /*
        Build video elements on ready.
        This has been altered as GTM needs the video to exist on initialize of the GTM tag. Previously this was being generated on click of play and the tag couldn't setup a listen event on the videos as they didn't exist.
    */
  playButton.each(function(index) {
    var thisButton = $(this);
    var videoId = thisButton.data("video-id");

    // Append iframe to container
    embedContainer.append(
      '<iframe data-src="https://www.youtube.com/embed/' +
        videoId +
        '?enablejsapi=1" id="lightbox-video-' +
        index +
        '" class="js-embedded-iframe"></iframe>'
    );
    thisButton.attr("data-lightbox", index);
  });

  // Show related iframe within lightbox on Play.
  playButton.on("click", function() {
    var thisButton = $(this);
    var thisTarget = thisButton.data("lightbox");

    // Hide iframes. Show target iframe.
    $("#lightbox-video-" + thisTarget).attr(
      "src",
      $("#lightbox-video-" + thisTarget).data("src")
    );
    $("#lightbox-video-" + thisTarget).show();

    // Show Lightbox
    $("main").addClass("off-canvas");
    $(".lightbox").addClass("is-visible");

    setTimeout(function() {
      embedContainer.addClass("is-visible");
    }, 750);
  });
}

function productFeaturesGrid() {
  if ($(".js-product-features-isotope").length && $(window).width() >= 768) {
    const grid = new Isotope(".js-product-features-isotope", {
      percentPosition: true,
      itemSelector: ".product-features__item",
      masonry: {
        columnWidth: ".grid-sizer",
        gutter: ".gutter-sizer",
      },
    });
  }
}

function archiveProductFilters() {
  $(".js-filter-products-view").on("click", function(e) {
    if (
      $(this)
        .parent()
        .hasClass("is-active")
    ) {
      e.preventDefault();
      if (
        $(this)
          .closest(".shop-filter-dropdown")
          .hasClass("is-active")
      ) {
        $(this)
          .closest(".shop-filter-dropdown")
          .removeClass("is-active");
      } else {
        $(this)
          .closest(".shop-filter-dropdown")
          .addClass("is-active");
      }
    } else {
    }
  });
}

/**
 * Partnership Logos Animation
 * Loops through each logo and randomly removes the greyscale
 */
function partnershipLogos() {
  var elementsLength = $(".js-partnership-logo-wrap").length;
  if (elementsLength) {
    var randomStartPoint = randomIntFromInterval(1, elementsLength);
    $(
      ".js-partnership-logo-wrap:nth-of-type(" + randomStartPoint + ")"
    ).addClass("is-active");

    // Push all the logos into an array
    var itemsLengthArray = [];
    for (var i = 1; i <= elementsLength; i++) {
      itemsLengthArray.push(i);
    }

    function loop(interval) {
      setTimeout(function() {
        // Reset the logos length array
        itemsLengthArray = [];
        for (var i = 1; i <= elementsLength; i++) {
          itemsLengthArray.push(i);
        }

        // Find the current active logo
        var currentActive =
          $(".partner-logos__wrap")
            .find(".is-active")
            .index() + 1;

        // Get the current active logo index in the array
        var index = itemsLengthArray.indexOf(currentActive);

        // Remove that current active logo from the array
        itemsLengthArray.splice(index, 1);

        // Choose the next random logo, exluding the previous active one
        var newActive =
          itemsLengthArray[Math.floor(Math.random() * itemsLengthArray.length)];

        $(".js-partnership-logo-wrap.is-active").removeClass("is-active");
        $(".js-partnership-logo-wrap:nth-of-type(" + newActive + ")").addClass(
          "is-active"
        );

        loop(2000);
      }, interval);
    }

    // Run the animation
    loop(2000);
  }
}

function snapHeightToVh() {
  var headerHeight = $(".header").outerHeight();
  var remainingSpace = $(window).height() - headerHeight;
  if ($(window).height() >= 920) {
    $(".js-snap-to-vh").css("height", remainingSpace);
  } else {
    $(".js-snap-to-vh").css("height", "initial");
  }
}

function videosSlider() {
  $(".js-video-slider").slick({
    dots: false,
    infinite: false,
    arrows: true,
    speed: 500,
    slidesToShow: 1.05,
    rows: 0,
    mobileFirst: true,
    responsive: [
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 2,
        },
      },
      {
        breakpoint: 1150,
        settings: {
          slidesToShow: 3,
        },
      },
    ],
  });

  $(".js-featured-videos-slider").slick({
    dots: false,
    infinite: false,
    arrows: true,
    speed: 500,
    slidesToShow: 1.05,
    rows: 0,
    mobileFirst: true,
    responsive: [
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 2,
        },
      },
      {
        breakpoint: 1023,
        settings: "unslick",
      },
    ],
  });
}

function filterTaxTypes() {
  var imgSrc = $(".footer .section-divider img").attr("src");
  $(".js-filter-tax-type").on("click", function() {
    var filter = $(this).data("filter");
    $(".js-filter-tax-type").removeClass("is-active");
    $(this).addClass("is-active");
    var newSrc = imgSrc.replace("offwhite", "white");

    if (filter == "all") {
      $(".js-filter-block").removeClass("is-filtered-current");
      $(".js-filter-block").addClass("is-active");
      if ($("body").hasClass("tax-tutorial_categories")) {
        // $('footer .section-divider').fadeIn();
        $(".footer .section-divider img").attr("src", imgSrc);
      }
    } else {
      if ($("body").hasClass("tax-tutorial_categories")) {
        // $('footer .section-divider').fadeOut();
        $(".footer .section-divider img").attr("src", newSrc);
      }
      $(".js-filter-block").removeClass("is-active");
      $(".js-filter-block").removeClass("is-filtered-current");
      $('.js-filter-block[data-id="' + filter + '"]').addClass("is-active");
      $('.js-filter-block[data-id="' + filter + '"]').addClass(
        "is-filtered-current"
      );
    }
  });
}

function filterTags() {
  $(".js-filter-tag-download").on("click", function() {
    var tag = $(this).data("filter");

    console.log(tag);

    $(".js-filter-tag-download").removeClass("is-active");
    $(this).addClass("is-active");

    if (tag === "all") {
      $(".download-card-grid-cell").show();
    } else {
      $(".download-card-grid-cell").hide();
      $(".download-card-grid-cell." + tag).show();
    }
  });
}

function siteSearch() {
  $(".js-toggle-site-search").on("click", function() {
    $(".site-search-form").toggleClass("is-active");
    $(".main-nav--right").toggleClass("is-hidden");
    setTimeout(function() {
      $(".site-search-form input").focus();
    }, 750);
  });

  $(".site-search-form .uil-multiply").on("click", function() {
    $(".site-search-form").removeClass("is-active");
    $(".main-nav--right").removeClass("is-hidden");
  });
}

function customCurrencySwitcher() {
  $(".wcpbc-currency-switcher option").each(function(i, obj) {
    var country = $(obj).val();
    var countryLabel = $(obj).data("currency");
    var elmClass = "js-trigger-custom-switcher custom-switcher__item";

    if ($(this).is(":selected")) {
      elmClass = "js-trigger-custom-switcher custom-switcher__item is-active";
    }
    $(obj)
      .closest(".custom-switcher-wrap")
      .find($(".custom-switcher"))
      .append(
        '<li class="' +
          elmClass +
          '" data-value="' +
          country +
          '">' +
          "<span class='custom-switcher__icon'>" +
          "<img alt=" +
          countryLabel +
          " src='" +
          urls.templateUrl +
          "/dist/img/flags/" +
          countryLabel +
          ".png'>" +
          "</span>" +
          countryLabel +
          "</li>"
      );
  });

  $(document).on("click", ".js-trigger-custom-switcher", function() {
    if ($(".custom-switcher").hasClass("is-active")) {
      $(".custom-switcher").removeClass("is-active");
    } else {
      $(".custom-switcher").addClass("is-active");
    }

    if ($(this).hasClass("is-active")) {
      console.log("is active one clicked");
    } else {
      $(".js-trigger-custom-switcher").removeClass("is-active");
      $(this).addClass("is-active");
      $(".wcpbc-currency-switcher")
        .find("option:selected")
        .attr("selected", false);
      var country = $(this).data("value");
      $(".wcpbc-currency-switcher")
        .find('option[value="' + country + '"]')
        .attr("selected", true);
      $(
        '#wcpbc-widget-country-switcher-form input[name="wcpbc-manual-country"]'
      ).val(country);
      $("#wcpbc-widget-country-switcher-form").submit();
    }
  });
}

function postsFiltersMobile() {
  $(".posts-list__filters").slick({
    dots: false,
    infinite: false,
    arrows: true,
    speed: 500,
    slidesToShow: 1,
    autoplay: false,
    centerMode: false,
    variableWidth: true,
    fade: false,
    rows: 0,
    draggable: true,
    mobileFirst: true,
    responsive: [
      {
        breakpoint: 1023,
        settings: "unslick",
      },
    ],
  });

  $(".filters-list").slick({
    dots: false,
    infinite: false,
    arrows: false,
    speed: 500,
    slidesToShow: 1,
    autoplay: false,
    centerMode: false,
    variableWidth: true,
    fade: false,
    rows: 0,
    draggable: true,
    mobileFirst: true,
    responsive: [
      {
        breakpoint: 1023,
        settings: "unslick",
      },
    ],
  });
}
